import { render, staticRenderFns } from "./BindWeChatTest.vue?vue&type=template&id=383ad52a&scoped=true&"
import script from "./BindWeChatTest.vue?vue&type=script&lang=js&"
export * from "./BindWeChatTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383ad52a",
  null
  
)

export default component.exports